import React from "react";
import "./TypingIndicator.css";

const TypingIndicator = () => {
  return (
    <div className="chatbot-message chatbot-message--assistant">
      <div className="chatbot-message-content">
        <div className="chatbot-typing-indicator">
          <div className="chatbot-typing-dots">
            <div className="chatbot-typing-dot"></div>
            <div className="chatbot-typing-dot"></div>
            <div className="chatbot-typing-dot"></div>
          </div>
          <span className="chatbot-typing-text">Typing...</span>
        </div>
      </div>
    </div>
  );
};

export default TypingIndicator;
